import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	ViewChild,
} from "@angular/core";
import _ from "lodash";
import { HelperService } from "@services/helper.service";
import { NgForm } from "@angular/forms";
import { ToolService } from "@services/tool.service";

import {
	WORK_ORDER_SEQUENCE_OPTIONS,
	EMAIL_VALIDATION_REGEX,
	WO_SEQUENCE,
} from "@constant";
import {
	WO_JOBSHEET_TYPE,
	WO_JOBSHEET_TYPES,
} from "@constants/work-order.contants";
import moment from "moment";
import { Observable, Subscription } from "rxjs";

import { first, finalize } from "rxjs/operators";

@Component({
	selector: "tool-UploadVendorProofFilesModal",
	templateUrl: "./UploadVendorProofFilesModal.component.html",
	styleUrls: ["./UploadVendorProofFilesModal.component.scss"],
})
export class UploadVendorProofFilesModal implements OnInit {
	@Output() responseSuccess = new EventEmitter();
	@ViewChild("RefModal") localModal;
	@ViewChild("RefFormHtml") RefFormHtml;
	@ViewChild("FileUploadRef") FileUploadRef;

	selectedToolRequests = [];

	constructor(
		private helperService: HelperService,
		private toolService: ToolService
	) {}

	ngOnInit() {}

	openModal(selectedToolRequests) {
		this.selectedToolRequests = [...selectedToolRequests];
		this.localModal.show();
	}

	getSaveValidationMessages() {
		let invalidFieldMessage = [];

		return invalidFieldMessage;
	}

	uploadFiles(event) {
		let { files } = event;

		let invalidFiles = this.helperService.validateFileFormat(files);
		if (invalidFiles.length > 0) {
			this.helperService.errorMessage(
				`Invalid file format: ${invalidFiles
					.map((f) => f.name)
					.join(", ")}`
			);
			return;
		}

		_.each(this.RefFormHtml.controls, (formControlRef, index) => {
			formControlRef.markAsDirty();
		});

		let invalidFieldMessage = this.getSaveValidationMessages();
		if (invalidFieldMessage.length > 0) {
			this.helperService.errorMessage(invalidFieldMessage[0]);
			return;
		}
		if (files.length === 0) {
			this.helperService.errorMessage("File is required");
			return;
		}

		let totalToUploadCount = files.length;
		let totalUploadedCount = 0;
		let totalUploadedSuccessCount = 0;

		_.each(files, (file) => {
			let params = {
				tool_request_id: _.chain(this.selectedToolRequests)
					.map("id")
					.head()
					.value(),
				proof_file: file,
			};

			this.toolService
				.uploadVendorProofFile(params)
				.pipe(
					first(),
					finalize(() => {
						totalUploadedCount++;
						if (totalUploadedCount == totalToUploadCount) {
							this.FileUploadRef.clear();
							this.responseSuccess.emit(true);

							if (
								totalUploadedSuccessCount == totalToUploadCount
							) {
								this.helperService.successMessage(
									"Successful Uploaded"
								);
							}
						}
					})
				)
				.subscribe(
					async (response: any) => {
						totalUploadedSuccessCount++;
					},
					async (error: any) => {
						this.helperService.errorMessage(
							`${file.name} -> ${error}`
						);
					}
				);
		});
	}

	onHideModal() {
		this.FileUploadRef.clear();
	}
}
